import { Flex } from "@chakra-ui/react";
import time from "src/utils/time";
import useAnimationFrameUpdater from "src/hooks/useAnimationFrameUpdater";
import { Caption } from "src/atoms/typography";
import Slider from "src/components/Slider";

export default function AudioPlayer({
  getCurrentTime,
  duration,
  onSeek,
  onSeekCommitted
}) {
  useAnimationFrameUpdater({ updateRate: 2 });
  const currentTime = getCurrentTime();
  return (
    <Flex width="100%" flex="1 1 auto" alignItems="center">
      <Caption
        color="mediumEmphasis"
        flexShrink={0}
        width="36px"
        textAlign="right"
        mr="12px"
      >
        {time.duration(currentTime).format("mm:ss")}
      </Caption>
      <Flex alignItems="center" flex="1 1 auto">
        <Slider
          value={currentTime}
          min={0}
          max={duration}
          step={1000}
          onChange={onSeek ? (value) => onSeek(value) : undefined}
          onChangeEnd={
            onSeekCommitted ? (value) => onSeekCommitted(value) : undefined
          }
        />
      </Flex>
      <Caption color="mediumEmphasis" flexShrink={0} width="36px" ml="12px">
        {time.duration(duration).format("mm:ss")}
      </Caption>
    </Flex>
  );
}
